"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_API_RATE_LIMIT_COST_CONFIG = exports.DEFAULT_API_RATE_LIMIT_ALGORITHM_CONFIG = exports.ApiRateLimitCategoryToFeatureName = void 0;
const types_1 = require("../../types");
const feature_tiers_constants_1 = require("../feature-tiers-constants");
exports.ApiRateLimitCategoryToFeatureName = {
    [types_1.ApiRateLimitCategoryEnum.TRIGGER]: feature_tiers_constants_1.FeatureNameEnum.PLATFORM_MAX_API_REQUESTS_TRIGGER_EVENTS,
    [types_1.ApiRateLimitCategoryEnum.CONFIGURATION]: feature_tiers_constants_1.FeatureNameEnum.PLATFORM_MAX_API_REQUESTS_CONFIGURATION,
    [types_1.ApiRateLimitCategoryEnum.GLOBAL]: feature_tiers_constants_1.FeatureNameEnum.PLATFORM_MAX_API_REQUESTS_GLOBAL,
};
exports.DEFAULT_API_RATE_LIMIT_ALGORITHM_CONFIG = {
    [types_1.ApiRateLimitAlgorithmEnum.BURST_ALLOWANCE]: 0.1, // allow 10% burst
    [types_1.ApiRateLimitAlgorithmEnum.WINDOW_DURATION]: 5, // 5 second window duration
};
exports.DEFAULT_API_RATE_LIMIT_COST_CONFIG = {
    [types_1.ApiRateLimitCostEnum.SINGLE]: 1,
    [types_1.ApiRateLimitCostEnum.BULK]: 100,
};
//# sourceMappingURL=apiRateLimits.js.map